import { MutationCache, QueryClient } from '@tanstack/react-query';
import { extractErrorMessage } from '@/lib/error-handling';
import { toast } from '@/stores/toast-store';

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error: any, _variables, _context, mutation) => {
      // Don't show toast if the mutation has its own onError handler
      if (mutation.options.onError) return;

      const message = extractErrorMessage(error) || 'An unexpected error occurred';

      toast.error(message);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error: any) => {
        const status = error?.response?.status;
        if (status && status >= 400 && status < 500 && status !== 429) return false;
        if (status === 429) return failureCount < 4;
        return failureCount < 2;
      },
      retryDelay: (attempt, error: any) => {
        const status = (error as any)?.response?.status;
        if (status === 429) return Math.min(5000 * Math.pow(2, attempt), 30000);
        return Math.min(1000 * Math.pow(2, attempt), 10000);
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: (failureCount, error: any) => {
        const status = error?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
    },
  },
});
